import { render, staticRenderFns } from "./IvaValueItem.vue?vue&type=template&id=2ba95f77&"
import script from "./IvaValueItem.vue?vue&type=script&lang=js&"
export * from "./IvaValueItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports